import { createReducer, on } from '@ngrx/store';
import { reset, saveFilterForm } from './actions';

export interface AppState {
	filtersValue: Map<string, any>;
}

const initAppState: AppState = {
	filtersValue: new Map()
};

export const filtersValueReducer = createReducer(
	initAppState,
	on(saveFilterForm, (state, { formKey, value }) => {
		const map = state.filtersValue;
		map.set(formKey, value);
		return { filtersValue: map };
	}),

	on(reset, () => {
		return { filtersValue: new Map() };
	})
);
